module.exports = __webpack_public_path__ + "static/media/feeling-neutral3.83c5226b.svg";